// probably dont change
export const BASENAME = "/";
export const MAINTENANCE_MODE = false;
export const SHOW_ADS = true;
export const APRIL_FOOLS = false;

// probably change
export const IS_PRODUCATION = true; // set false to use localhost endpoints
export const TRANSLATION_VERSION = 0.319; // increment this when translation keys are outdated
